import request from "./request";

export async function scan(articleId) {
  const resp = await request()
    .get("/article/scan/" + articleId)
    .then(resp => resp.data);
  return resp;
}

export async function getArticles(page = 1, limit = 10, typeid = -1) {
  const query = {
    page,
    limit
  };
  typeid !== -1 && (query.typeid = typeid);
  const resp = await request()
    .get("/article", {
      params: query
    })
    .then(resp => resp.data);
  return resp;
}

export async function addArticle(articleObj) {
  const resp = await request()
    .post("/article/add", articleObj)
    .then(resp => resp.data);
  return resp;
}

export async function deleteArticle(id) {
  const resp = await request()
    .get(`/article/delete/${id}`)
    .then(resp => resp.data);
  return resp;
}

export async function updateArticle(id, articleObj) {
  const resp = await request()
    .post(`/article/update/${id}`, articleObj)
    .then(resp => resp.data);
  return resp;
}

export async function getArticleById(id) {
  const resp = await request()
    .get(`/article/${id}`)
    .then(resp => resp.data);
  return resp;
}
